import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import { BaseLeadPage, CarleadStep2CustomerPopupBuyCar, CarleadTopBlueCarHCSliderMap, } from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <BaseLeadPage
      form={CarleadStep2CustomerPopupBuyCar}
      content={CarleadTopBlueCarHCSliderMap}
      className='mobile-blue-bg'
      howItWorksShowCta={false}
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
